import { Injectable, Injector } from "@angular/core";
import { PackagePlatformService } from "./package-plateform.service";
import { EPackageType } from "../enum/e-package-type";
import { PackageService } from "./package.service";

@Injectable({
    providedIn: 'root'
  })
export class PackageFactoryService {

    constructor(private injector : Injector){

    }

    create(type : EPackageType) : PackageService {

        let packService = null;

        if(type == EPackageType.Plateform){
            packService = this.injector.get(PackagePlatformService);
        }
        else{
            throw new Error("No packService for this Type ! ");
        }

        return packService;
    }

}